<div class="inventory-label">
  <div class="left-side-content">
    <img
      *ngIf="data | getVariantAssetForCard | async as variantAsset"
      appImage
      class="brand-logo"
      [asset]="variantAsset"
      src=""
      alt="" />
  </div>
  <div class="center-content">
    <div class="name-and-brand">
      <div
        appPrintCardScaleDownText
        [maxHeightInPx]="45"
        [maxWidthInPx]="140"
        [decrementFontSizeByNPixelsPerStep]="0.1"
        [useFloatingPointPixels]="true"
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
        class="product-name-text">
        {{ viewModel.productName$ | async }}
      </div>
      <div
        *ngIf="viewModel.brand$ | async as brand"
        class="brand-name-text"
        appPrintCardScaleDownText
        [maxHeightInPx]="12"
        [maxWidthInPx]="140"
        [decrementFontSizeByNPixelsPerStep]="0.1"
        [useFloatingPointPixels]="true"
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
        {{ brand }}
      </div>
    </div>
    <ng-container
      *rxLet="
        viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true : true : false | async as size
      ">
      <ng-container *rxLet="viewModel.variantType$ | async as variantType">
        <div *ngIf="size || variantType" class="size-and-variant-type">
          <div *ngIf="size" class="size-text">
            {{ (size | stringIncludes: 'capsule' : true) ? (size | replace: ' Capsule(s)*' : '') : size }}
          </div>
          <div *ngIf="variantType" class="variant-type-text">
            {{ (size | stringIncludes: 'capsule' : true) ? (size | replace: '\\d* ' : '') : variantType }}
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="right-side-content">
    <div class="product-image-stamp" [style.background-color]="viewModel.productAssetBackgroundColor$ | async">
      <img
        *ngIf="viewModel.labelAssetUrl$ | async as labelAssetUrl"
        class="product-image"
        [src]="labelAssetUrl"
        alt="product image" />
    </div>
  </div>
</div>
